import { useCallback, useState } from "react";


export function useShuffle(
  default_triggered: boolean
): [number, (trigger: boolean) => void] {
  const [value, setValue] = useState(default_triggered ? 1 : 0);


  const setParam = useCallback((trigger: boolean) => {
    if (trigger) {
      setValue(value + 1)
    } else {
      setValue(0);
    }
  }, [value, setValue]);

  return [value, setParam];
}
